/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  CancelWireModelDto,
  CountryModelDto,
  CurrencyModelDto,
  ErrorHttpContentDto,
  FileFormatModelDto,
  FileImportLayoutFieldModelDto,
  LookupListModelDto,
  LookupModelDto,
  PagedListModelWireFileModelDto,
  ProductTypeModelDto,
  RateQuoteModelDto,
  RequestQuoteModelDto,
  UserModelDto,
  WireFileModelDto,
  WireFileSearchCriteriaModelDto,
  WireListModelDto,
  WireModelDto,
  WireParseResultModelDto,
  WireProcessResultModelDto,
  WireSearchCriteriaModelDto,
  WireSearchModelDto,
  WireTemplateModelDto,
  WireTemplateSearchModelDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class WiresClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Countries
   * @name CountriesGet2
   * @summary Gets all Countries.
   * @request GET:/wires/countries
   */
  countriesGet2 = (params: RequestParams = {}) =>
    this.http.request<CountryModelDto[], any>({
      path: `/wires/countries`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetAll
   * @summary Gets all wires available to the current user.
   * @request GET:/wires
   */
  wiresGetAll = (params: RequestParams = {}) =>
    this.http.request<WireModelDto[], ErrorHttpContentDto>({
      path: `/wires`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresPost
   * @summary Creates a new wire.
   * @request POST:/wires
   */
  wiresPost = (data: WireModelDto, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresDelete
   * @summary Cancels a wire.
   * @request DELETE:/wires
   */
  wiresDelete = (data: CancelWireModelDto, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGet
   * @summary Gets a single wire by identifier.
   * @request GET:/wires/{id}
   */
  wiresGet = (id: number, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresPut
   * @summary Updates an existing wire.
   * @request PUT:/wires/{id}
   */
  wiresPut = (id: number, data: WireModelDto, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresSearch
   * @summary Searches for wires based on criteria and type.
   * @request POST:/wires/search
   */
  wiresSearch = (
    data: WireSearchCriteriaModelDto,
    query?: {
      /** Wire type (OneTime, Recurring). */
      type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireModelDto[], ErrorHttpContentDto>({
      path: `/wires/search`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetByType
   * @summary Gets wires of a specific type.
   * @request GET:/wires/getByType
   */
  wiresGetByType = (
    query?: {
      /** Wire type filter. */
      type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireModelDto[], ErrorHttpContentDto>({
      path: `/wires/getByType`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresApprove
   * @summary Approves a wire.
   * @request POST:/wires/{id}/approve
   */
  wiresApprove = (id: number, data: LookupModelDto, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires/${id}/approve`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresReject
   * @summary Rejects a wire.
   * @request POST:/wires/{id}/reject
   */
  wiresReject = (id: number, data: LookupModelDto, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires/${id}/reject`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresApproveTemplate
   * @summary Approves a wire template.
   * @request POST:/wires/approveTemplate/{id}
   */
  wiresApproveTemplate = (id: number, data: LookupModelDto, params: RequestParams = {}) =>
    this.http.request<WireTemplateModelDto, ErrorHttpContentDto>({
      path: `/wires/approveTemplate/${id}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresRejectTemplate
   * @summary Rejects a wire template.
   * @request POST:/wires/rejectTemplate/{id}
   */
  wiresRejectTemplate = (id: number, data: LookupModelDto, params: RequestParams = {}) =>
    this.http.request<WireTemplateModelDto, ErrorHttpContentDto>({
      path: `/wires/rejectTemplate/${id}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresCancel
   * @summary Cancels a wire (PUT variant maintained for legacy clients).
   * @request PUT:/wires/cancel
   */
  wiresCancel = (data: CancelWireModelDto, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires/cancel`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetNewWireQuote
   * @summary Gets a rate quote for a prospective wire.
   * @request POST:/wires/getNewWireQuote
   */
  wiresGetNewWireQuote = (data: RequestQuoteModelDto, params: RequestParams = {}) =>
    this.http.request<RateQuoteModelDto, ErrorHttpContentDto>({
      path: `/wires/getNewWireQuote`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresAcceptNewWireQuote
   * @summary Accepts a previously obtained rate quote and creates the wire.
   * @request POST:/wires/acceptNewWireQuote
   */
  wiresAcceptNewWireQuote = (data: WireModelDto, params: RequestParams = {}) =>
    this.http.request<WireModelDto, ErrorHttpContentDto>({
      path: `/wires/acceptNewWireQuote`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresBatch
   * @summary Batch approve / reject wires.
   * @request POST:/wires/{id}/batch
   */
  wiresBatch = (
    id: number,
    data: LookupListModelDto,
    query?: {
      /** Action to perform (Approve/Reject). */
      action?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireListModelDto, ErrorHttpContentDto>({
      path: `/wires/${id}/batch`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresInitiateBulkWires
   * @summary Initiates bulk wires in a single request.
   * @request POST:/wires/initiateBulk
   */
  wiresInitiateBulkWires = (data: WireListModelDto, params: RequestParams = {}) =>
    this.http.request<WireListModelDto, ErrorHttpContentDto>({
      path: `/wires/initiateBulk`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetInternationalWireCurrencies
   * @summary Returns international wire currencies available for processing.
   * @request GET:/wires/getInternationalWireCurrencies
   */
  wiresGetInternationalWireCurrencies = (params: RequestParams = {}) =>
    this.http.request<CurrencyModelDto[], ErrorHttpContentDto>({
      path: `/wires/getInternationalWireCurrencies`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetTemplate
   * @summary Gets a wire template by identifier.
   * @request GET:/wires/getTemplate/{id}
   */
  wiresGetTemplate = (id: number, params: RequestParams = {}) =>
    this.http.request<WireTemplateModelDto, ErrorHttpContentDto>({
      path: `/wires/getTemplate/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresPostAll
   * @summary Searches for wire templates.
   * @request POST:/wires/wireTemplateSearch
   */
  wiresPostAll = (data: WireTemplateSearchModelDto, params: RequestParams = {}) =>
    this.http.request<WireTemplateModelDto[], ErrorHttpContentDto>({
      path: `/wires/wireTemplateSearch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresValidateTemplateName
   * @summary Validates whether a wire template name is unique/allowed.
   * @request GET:/wires/validateTemplateName
   */
  wiresValidateTemplateName = (
    query?: {
      /** Template name to validate. */
      templateName?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/wires/validateTemplateName`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresCreateTemplate
   * @summary Creates a new wire template.
   * @request POST:/wires/createTemplate
   */
  wiresCreateTemplate = (data: WireTemplateModelDto, params: RequestParams = {}) =>
    this.http.request<WireTemplateModelDto, ErrorHttpContentDto>({
      path: `/wires/createTemplate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresUpdateTemplate
   * @summary Updates an existing wire template.
   * @request PUT:/wires/updatetemplate/{id}
   */
  wiresUpdateTemplate = (id: number, data: WireTemplateModelDto, params: RequestParams = {}) =>
    this.http.request<WireTemplateModelDto, ErrorHttpContentDto>({
      path: `/wires/updatetemplate/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresDeleteTemplate
   * @summary Deletes a wire template.
   * @request DELETE:/wires/template/{id}
   */
  wiresDeleteTemplate = (id: number, params: RequestParams = {}) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/wires/template/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetFileFormat
   * @summary Gets a file format by identifier.
   * @request GET:/wires/fileFormat/{id}
   */
  wiresGetFileFormat = (id: number, params: RequestParams = {}) =>
    this.http.request<FileFormatModelDto, ErrorHttpContentDto>({
      path: `/wires/fileFormat/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresUpdateFileFormat
   * @summary Updates a file format.
   * @request PUT:/wires/fileFormat/{id}
   */
  wiresUpdateFileFormat = (id: number, data: FileFormatModelDto, params: RequestParams = {}) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/wires/fileFormat/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresDeleteFileFormat
   * @summary Deletes a file format.
   * @request DELETE:/wires/fileFormat/{id}
   */
  wiresDeleteFileFormat = (id: number, params: RequestParams = {}) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/wires/fileFormat/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetFileFormats
   * @summary Gets all file formats.
   * @request GET:/wires/fileFormat
   */
  wiresGetFileFormats = (params: RequestParams = {}) =>
    this.http.request<FileFormatModelDto[], ErrorHttpContentDto>({
      path: `/wires/fileFormat`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresCreateFileFormat
   * @summary Creates a file format.
   * @request POST:/wires/fileFormat
   */
  wiresCreateFileFormat = (data: FileFormatModelDto, params: RequestParams = {}) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/wires/fileFormat`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetFileFormatFields
   * @summary Gets file format field definitions for Domestic Wire file type.
   * @request GET:/wires/fileFormatField
   */
  wiresGetFileFormatFields = (params: RequestParams = {}) =>
    this.http.request<FileImportLayoutFieldModelDto, ErrorHttpContentDto>({
      path: `/wires/fileFormatField`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresParseIssuedItems
   * @summary Parses an uploaded wire file (multipart/form-data) and returns parsed wires / errors.
   * @request POST:/wires/parseWireFile
   */
  wiresParseIssuedItems = (params: RequestParams = {}) =>
    this.http.request<WireParseResultModelDto, ErrorHttpContentDto>({
      path: `/wires/parseWireFile`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresSearchFile
   * @summary Searches for uploaded wire files.
   * @request POST:/wires/fileSearch
   */
  wiresSearchFile = (data: WireFileSearchCriteriaModelDto, params: RequestParams = {}) =>
    this.http.request<PagedListModelWireFileModelDto, ErrorHttpContentDto>({
      path: `/wires/fileSearch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresSearchFileAll
   * @summary Gets list of users who can upload domestic wire files.
   * @request GET:/wires/getDomesticWireFileUploadUsers
   */
  wiresSearchFileAll = (params: RequestParams = {}) =>
    this.http.request<UserModelDto[], ErrorHttpContentDto>({
      path: `/wires/getDomesticWireFileUploadUsers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresProcessWireFile
   * @summary Processes a stored wire file by identifier.
   * @request POST:/wires/processWireFile/{id}
   */
  wiresProcessWireFile = (id: string, params: RequestParams = {}) =>
    this.http.request<WireProcessResultModelDto, ErrorHttpContentDto>({
      path: `/wires/processWireFile/${id}`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetWireFile
   * @summary Retrieves metadata for a previously uploaded wire file.
   * @request POST:/wires/wireFile/{id}
   */
  wiresGetWireFile = (id: string, params: RequestParams = {}) =>
    this.http.request<WireFileModelDto, ErrorHttpContentDto>({
      path: `/wires/wireFile/${id}`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresDeleteWireFile
   * @summary Deletes a previously uploaded wire file.
   * @request DELETE:/wires/wireFile/{id}
   */
  wiresDeleteWireFile = (id: string, params: RequestParams = {}) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/wires/wireFile/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresSearchWithTotals
   * @summary Searches wires with totals (status grouping) - v2 endpoint.
   * @request POST:/wires/search/v2
   */
  wiresSearchWithTotals = (
    data: WireSearchCriteriaModelDto,
    query?: {
      /** Wire type (OneTime, Recurring). */
      type?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireSearchModelDto, ErrorHttpContentDto>({
      path: `/wires/search/v2`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wires
   * @name WiresGetCorpaySsoLogin
   * @summary Gets the Corpay SSO login information for the current user/company.
   * @request GET:/wires/corpay/sso
   */
  wiresGetCorpaySsoLogin = (params: RequestParams = {}) =>
    this.http.request<ProductTypeModelDto, ErrorHttpContentDto>({
      path: `/wires/corpay/sso`,
      method: "GET",
      format: "json",
      ...params,
    });
}
